<template>
  <div class="upload-cert-container upload-career-container">
    <template v-if="status === 0">
      <div class="upload-tips">拍照上传工卡照（或名片、营业执照、劳动合同）</div>
      <div class="photo-item">

        <Oss @uploadSucess="uploadSuccess" browse_button="uploadWorkBtn" @fileChange="selectedFile"
          :args="{key:'workFile'}" :actionFile="workFile" container="workContainer" :params='workParams'>
          <div id="workContainer" class="photo-item">

            <div id="uploadWorkBtn" v-if="workPicUrlList && workPicUrlList.length">
              <img :src="workPicUrlList[0]" alt="点击拍摄工卡照片" class="img" />
            </div>
            <div id="uploadWorkBtn" v-else>
              <img src="~@/assets/img/cert-career.png" alt="点击拍摄工卡照片" class="img" />
            </div>

            <!-- <img v-if="workPicUrlList && workPicUrlList.length" :src="workPicUrlList[0]" id="uploadWorkBtn"
              alt="点击拍摄工卡照片" class="img" />
            <img v-else src="~@/assets/img/cert-career.png" alt="点击拍摄工卡照片" id="uploadWorkBtn" class="img" /> -->
          </div>

        </Oss>

      </div>
      <a href="javascript:;" class="commit common-btn" :class="{disable: !workPicList || workPicList.length === 0}"
        @click="commit">提交认证</a>
    </template>
    <template v-else>
      <div class="process">
        <ul class="process-list">
          <li class="process-item">
            <p class="date">{{userData.workCommitTime | formatTime}}</p>
            <p class="option">你提交了工作认证信息</p>
            <div class="imgs">
              <img v-if="workPicUrlList && workPicUrlList.length" :src="workPicUrlList[0]" class="img" />
              <img src="~@/assets/img/certed.png" alt="已认证" class="certed" v-if="status === 3" />

            </div>
          </li>
          <li class="process-item">
            <p class="option" v-if="status === 1">待后台审核…</p>
            <template v-if="status === 2">
              <p class="date">{{userData.workAuthTime | formatTime}}</p>
              <p class="option">后台审核不通过，</p>
              <p class="reason"><span class="strong">不通过原因：</span>{{userData.workAuthReason}}</p>
            </template>
            <template v-if="status === 3">
              <p class="date">{{userData.workAuthTime | formatTime}}</p>
              <p class="option">后台审核通过</p>
            </template>
          </li>
        </ul>
        <a href="javascript:;" class="re-commit common-btn" v-if="status === 2 || status === 3" @click="reCert">重新认证</a>
      </div>
    </template>

    <p class="tips">1、在读学生可上传学生证/录取通知书等进行认证。</p>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

import { isIOS, transferBytes, watermark } from '@/utils/tools'
import { UPLOAD_TYPE } from '@/config/constant'
import Oss from '@/components/common/oss'

// const getRotate = () => {
//   return import('@/utils/rotateImg.js')
// }

export default {
  name: 'uploadCert',
  components: {
    Oss
  },
  computed: {
    ...mapState({
      userData: 'userData'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    status () {
      return this.userData.workAuth
    }
  },
  watch: {
    userData (val) {
      if (val) {
        this.workPicList = this.userData.workPicList
        this.workPicUrlList = this.userData.workPicUrlList
      }
    }
  },
  data () {
    return {
      // 0: 未上传; 1: 待审核; 2: 未通过; 3: 通过
      workPicList: [],
      workPicUrlList: [],
      workFile: null,
      workParams: { type: UPLOAD_TYPE.work }
    }
  },
  methods: {
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),

    // 正面
    uploadSuccess ({ picId, url, args }) {
      // console.log('ssd====>', { picId, url, args })
      let { key } = args
      // this[pathKey] = url
      this[key] = null
      this.workPicUrlList = [url]
      this.workPicList = [picId]
    },

    selectedFile (e) {
      this[e.args.key] = e.file
    },

    commit () {
      if (this.workPicList.length) {
        this.$root.openLoading()
        // 保存个人信息
        this.$http('/api/member/save', {
          workPicList: this.workPicList,
          workAuth: 1
        }).then(res => {
          this.$root.closeLoading()
          if (res.code === '0000') {
            // 更新个人信息
            this.updateUserData({
              workPicList: this.workPicList,
              workPicUrlList: this.workPicUrlList,
              workAuth: 1,
              workCommitTime: new Date().getTime()
            })
          } else {
            this.$toast(res.msg)
          }
        }, err => {
          this.$root.closeLoading()
          this.$toast(err)
        })
      }
    },
    reCert () {
      this.updateUserData({
        workPicList: null,
        workAuth: 0
      })
    }
  },
  mounted () {
    // if (this.userData.workPicList) {
    //   this.workPicList = this.userData.workPicList
    // }

    let { workPicList, workPicUrlList } = this.userData
    if (workPicList && workPicList.length && workPicUrlList && workPicUrlList.length) {
      this.workPicList = workPicList || []
      this.workPicUrlList = workPicUrlList || []
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.upload-cert-container.upload-career-container {
  .photo-item {
    height: 624px;
  }
  .imgs {
    .img {
      margin-right: 20px;
      // width: 140px;
      // height: auto !important;
    }
  }
  .tips {
    margin-top: 150px;
    color: #9b9b9b;
    font-size: 28px;
    line-height: 40px;
  }
}
// #workContainer {
//   height: 450px;
//   position: relative;
//   border-radius: 15px;
//   display: block;
//   margin: 0 auto;
// }
.upload-cert-container .photo-item .img {
  position: relative;
  border-radius: 15px;
  display: block;
  margin: 0 auto;
  max-height: 650px;
  // width: 300px;
}
</style>
